import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid md:grid-cols-2 gap-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "md:text-lg leading-6 font-medium text-gray-900" }, "Today", -1)
const _hoisted_3 = { class: "grid grid-cols-2 mt-5 gap-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "md:text-lg leading-6 font-medium text-gray-900" }, "Last 7 Days", -1)
const _hoisted_5 = { class: "grid grid-cols-2 mt-5 gap-8" }

import { useSupplier } from "@/composables/supplier";
import Stat from "@/components/Stat.vue";
import { round } from "lodash";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { supplier } = useSupplier();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(Stat, {
            title: "Orders",
            value: _unref(supplier)?.totalOrdersToday
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(Stat, {
            title: "Total Value (USD)",
            value: 
              _unref(supplier)?.totalOrdersCostToday &&
              `$${_unref(round)(_unref(supplier).totalOrdersCostToday)}`
            
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(Stat, {
            title: "Orders",
            value: _unref(supplier)?.totalOrders7Days
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(Stat, {
            title: "Total Value (USD)",
            value: 
              _unref(supplier)?.totalOrdersCost7Days &&
              `$${_unref(round)(_unref(supplier).totalOrdersCost7Days)}`
            
          }, null, 8, ["value"])
        ])
      ])
    ])
  ]))
}
}

})